import api from "../utils/axiosInstance";
import * as C from "../constants/newsletterConstants";
import { getApiErrorMessage } from "../utils/errorMessages";

function safeText(value = "") {
  return String(value ?? "").trim();
}

function normalizeApiError(error, fallback) {
  return getApiErrorMessage(error, { fallback });
}

export const subscribeToNewsletter =
  ({ email = "", source = "home_newsletter", website = "" } = {}) =>
  async () => {
    try {
      const { data } = await api.post("/newsletter/subscribe", {
        email: safeText(email).toLowerCase(),
        source: safeText(source) || "home_newsletter",
        website: safeText(website),
      });

      return data;
    } catch (error) {
      throw new Error(
        normalizeApiError(
          error,
          "We could not save your subscription right now. Please try again later.",
        ),
      );
    }
  };

export const unsubscribeFromNewsletter = (token = "") => async () => {
  try {
    const { data } = await api.post("/newsletter/unsubscribe", {
      token: safeText(token),
    });

    return data;
  } catch (error) {
    throw new Error(
      normalizeApiError(
        error,
        "We could not update your newsletter subscription right now.",
      ),
    );
  }
};

export const listNewsletterSubscribersAdmin =
  (params = {}) =>
  async (dispatch) => {
    try {
      dispatch({ type: C.NEWSLETTER_ADMIN_LIST_REQUEST });

      const { data } = await api.get("/newsletter/admin", { params });

      dispatch({
        type: C.NEWSLETTER_ADMIN_LIST_SUCCESS,
        payload: data,
      });

      return data;
    } catch (error) {
      const payload = normalizeApiError(
        error,
        "We could not load newsletter subscribers right now.",
      );

      dispatch({
        type: C.NEWSLETTER_ADMIN_LIST_FAIL,
        payload,
      });

      throw new Error(payload);
    }
  };

export const sendNewsletterAdmin =
  ({ subject = "", message = "" } = {}) =>
  async (dispatch) => {
    try {
      dispatch({ type: C.NEWSLETTER_SEND_REQUEST });

      const { data } = await api.post(
        "/newsletter/admin/send",
        {
          subject: safeText(subject),
          message: String(message ?? "").trim(),
        },
        { timeout: 5 * 60 * 1000 },
      );

      dispatch({ type: C.NEWSLETTER_SEND_SUCCESS, payload: data });
      return data;
    } catch (error) {
      const payload = normalizeApiError(
        error,
        "We could not send this newsletter right now.",
      );

      dispatch({ type: C.NEWSLETTER_SEND_FAIL, payload });
      throw new Error(payload);
    }
  };

export const exportNewsletterSubscribersAdmin = async () => {
  try {
    const { data } = await api.get("/newsletter/admin/export");
    return data;
  } catch (error) {
    throw new Error(
      normalizeApiError(
        error,
        "We could not export active newsletter subscribers right now.",
      ),
    );
  }
};
